import { Component, Input, OnInit } from '@angular/core';

import { TermsConditions } from '@shared/terms-conditions/models/terms-conditions.model';

@Component({
    selector: 'app-input-terms-conditions-term',
    templateUrl: './terms.component.html',
})

/**
 * Componente para mostrar elementos del campo Términos y condiciones con un popup
 */
export class InputTermsConditionsTermComponent implements OnInit {
    @Input() public data: TermsConditions;

    @Input() public termsTextNumber: number;

    @Input() public termsData: any;

    public linetermsMessage: any;

    constructor() {
        //
    }

    public ngOnInit(): void {
        this.linetermsMessage = this.data.messages['text' + this.termsTextNumber];
    }
}
